export const hasActiveApikey = (data) => {
    try {
        const areEnabledApiKeys = getAreEnabledCredentials(data.merchantApiCredentials);
        return areEnabledApiKeys.some(isEnabled => isEnabled);
    }
    catch (e) {
        return false;
    }
};
const getAreEnabledCredentials = (credentials) => {
    return credentials.map(credential => {
        const enabledProperty = getIsEnabledProperty(credential);
        if (!enabledProperty)
            return false;
        return enabledProperty.value === 'true';
    });
};
const getIsEnabledProperty = (credential) => credential.properties.find(property => property.name === 'enabled');
